export const MediaDragBadge = ({ count }: { count: number }) => (
  <span
    style={{
      position: "absolute",
      top: -8,
      left: -8,
      minWidth: 22,
      height: 22,
      padding: "0 6px",
      borderRadius: 11,
      background: "#1677ff",
      color: "#fff",
      fontSize: 12,
      fontWeight: 700,
      lineHeight: "22px",
      textAlign: "center",
      boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
      zIndex: 10,
      pointerEvents: "none",
    }}
  >
    {count}
  </span>
);

export default MediaDragBadge;
